// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__O44Sx","project":"Projects_project__bBh0y","projects__label":"Projects_projects__label__q8vkI"};